module.exports = __webpack_public_path__ + "img/pc_banner_sup_shop.ec86e909.webp";